export default function (state) {
    state.system.tab = 'form';
    state.system.action = 'add';
    state.system.IncomePaymentNumber = '';
    state.system.OutcomePaymentNumber = '';
    state.system.code = '';
    state.system.subAgent = false;
    state.system.reservationCenter = false;
    state.system.manager = '';
    state.system.PaySystemType = '';
    state.system.createDate = '';
    state.system.none = false;
    state.options.legals = [];
    state.form.Id = 0;
    state.form.RegularPaymentId = 0;
    state.form.Name = '';
    state.form.NameLat = '';
    state.form.PaymentDirection = 0;
    state.form.PaymentOperationID = 0;
    state.form.RateArticleId = null;
    state.form.CategoryId = 0;
    state.form.PaymentTypeId = 0;
    state.form.CashId = 0;
    state.form.PaymentAccountId = 0;
    state.form.AccountNumber = '';
    state.form.ContragentType = 0;
    state.form.ContragentID = null;
    state.form.ContragentName = '';
    state.form.PartnerLegalEntityId = null;
    state.form.Sum = 0;
    state.form.BankCommission = 0;
    state.form.CurrencyId = 0;
    state.form.PaymentDate = '';
    state.form.DocumentNumber = '';
    state.form.PaymentFor = '';
    state.form.Comment = '';
    state.form.RegularPaymentTypeId = 0;
    state.form.dayMonth = 1;
    state.form.dayWeek = 1;
    state.form.dayYear = '';
    state.form.dayOne = '';
    state.form.NotificationsEndDate = '';
    state.form.AgreementCodes = [];
    state.form.addCashCheck = false;
    state.form.OnlineCashId = 0;
    state.form.BillProvideTypeId = 1;
    state.form.AdditionalValues = [];

    state.agreements.list = [];
    state.files.list = [];
    state.files.data.paymentId = 0;
    state.files.counter = 0;
    state.files.load = false;
    state.regulars.list = [];
    state.invoices.list = [];
}
